import { apiRequest } from "../util/apiUtils";

export const getFaqList = async (params) => {
  try {
    const res = await apiRequest("get", "admin/faqs/list", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const changeFaqStatus = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/faqs/status-change", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
    throw err;
  }
};

export const deleteFaq = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/faqs/delete", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
    throw err;
  }
};

export const addFaq = async (params) => {
  try {
    const res = await apiRequest(
      params.id ? "post" : "post",
      params.id ? "admin/faqs/edit" : "admin/faqs/add",
      {
        body: { ...params },
      }
      // "multipart/form-data"
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const faqDetails = async (params) => {
  try {
    const res = await apiRequest("get", `admin/faqs/details/${params?.id}`, {});
    return res?.data;
  } catch (err) {
    return err;
  }
};
